import React from 'react';
import { Header } from '../header';
import { Footer } from '../footer';
import { useLayoutContext } from '@assets/spa/context/layout';
export default function Main({ children, bodyClass }) {
    const [layout] = useLayoutContext();
    return (React.createElement("div", { className: `${bodyClass || (layout === null || layout === void 0 ? void 0 : layout.bodyClass) || ''}` },
        React.createElement(Header, null),
        React.createElement("main", null, children),
        React.createElement(Footer, null)));
}
